import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { StiiizyBusinessCardStackContentViewModel } from './stiiizy-business-card-stack-content-view-model';
import { StiiizyCardData } from '../../../../../../../models/print-cards/stiiizy-card-data';

@Component({
  selector: 'app-stiiizy-business-card-stack-content',
  templateUrl: './stiiizy-business-card-stack-content.component.html',
  styleUrls: ['./stiiizy-business-card-stack-content.component.scss'],
  providers: [StiiizyBusinessCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class StiiizyBusinessCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: StiiizyBusinessCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override data: StiiizyCardData;
}
